module.exports = __webpack_public_path__ + "static/media/j.51156a8d.png";